import { extractGraphQLError } from './graphqlError';

type ToastLike = { add: (message: { severity: 'error'; summary: string; detail: string; life: number }) => void };

/**
 * A `.catch` handler for a mutation: toast why it failed, then rethrow so the
 * caller can still map field errors (useFormErrors) or keep its dialog open.
 *
 * `await mutate(vars).catch(toastAndRethrow(toast, "Couldn't approve graduation"))`
 */
export function toastAndRethrow(toast: ToastLike, summary: string) {
  return (error: unknown): never => {
    toast.add({ severity: 'error', summary, detail: extractGraphQLError(error), life: 6000 });
    throw error;
  };
}
